import React, { useContext, useState, useEffect } from 'react';
import { AppContext, AuthContext } from 'Context';
import { FormGroup, FormControlLabel, Checkbox, Box } from '@material-ui/core';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { STRIPE_PUBLIC_KEY } from 'Api';
import CheckoutElementsStripe from './CheckoutElementsStripe';
import PageLayout from '../page-layout';

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const StripeElements = () => {
  const { stripeUiSelector, setisFromAffl, isFromAffl, setAppSnackbar, screatId } = useContext(AppContext);
  console.log('stripeUiSelector', stripeUiSelector, screatId);
  const options = {
    clientSecret: screatId,
    appearance: {
      theme: 'flat',
      // variables: {
      //   colorPrimary: '#0570DE',
      //   colorBackground: '#FFFFFF',
      //   colorText: '#30313D',
      //   colorDanger: '#DF1B41',
      //   fontFamily: 'Ideal Sans, system-ui, sans-serif',
      //   spacingUnit: '2px',
      //   borderRadius: '4px',
      //   // See all possible variables below
      // }
    },
  };
  return (
    <Box bgcolor="#FAFBFC">
      <Elements stripe={stripePromise} options={options}>
        <CheckoutElementsStripe />
      </Elements>
    </Box>
  );
};

export default StripeElements;
